import React from "react";
import { Container, Box } from "@mui/material";
import { useLocation } from "react-router-dom";

import ChiFooter from "works/chi/components/Footer";

function ChiAppLayout({ children }) {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  // クエリパラメータを取得
  const soulId = queryParams.get("soul_id");

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: "url(/chi/background.png)", // publicフォルダの画像を使用
        backgroundSize: "100% auto",
      }}
    >
      <Container
        sx={{
          width: "88%", // 幅を80%に設定
          minHeight: "100vh",
        }}
      >
        {children}
      </Container>

      <ChiFooter soulId={soulId} />
    </Box>
  );
}

export default ChiAppLayout;
